<div class="cj-reduction cj-red-1">
  <div class="circle-bg"></div>
  <header class="seges" *ngIf="isSegurosUser">
    <div class="container-header">
      <a href="https://www.seguros.es" target="_blank" class="logo"><img
          src="https://www.seguros.es/wp-content/themes/seges/assets/img/logo-seguros-es.svg" width="157" height="28"
          alt="Logo seguros.es"></a>
    </div>
  </header>
  <div class="container">
    <div class="row row-flex cj-reduction-logo upa-login" [class.hidden]="isMobileApp">
      <div class="cj-landing-header">
        <div class="cj-header-logo">
          <a class="cj-logo" href="https://www.rastreator.com" target="_blank" title="Go to Rastreator website">
            <img class="hidden-xs" src="{{baseMakeImageUrl}}rastreator.svg" alt="Rastreator.com">
            <img class="visible-xs" src="{{baseMakeImageUrl}}logo-icon-rastreator.svg" alt="Rastreator.com">
          </a>
        </div>
        <div class="header-right-section">
          <div class="user-login" id="upa-login-trigger" (click)="loginTriggerClick()">

          </div>
        </div>
      </div>
    </div>
    <div class="row row-flex" [class.upa-user-profile]="isUpaProfile">
      <div class="cj-landing-row">
        <div class="cj-landing-header">
          <div class="cj-header-logo">
            <div class="header-logo-section" [class.hidden]="isMobileApp">
              <img class="head-ras-icon" src="{{baseMakeImageUrl}}icons-rastreator-insurances-death-insurance.svg">
              <img class="head-ras-icon-wl"
                src="{{baseMakeImageUrl}}icons-rastreator-insurances-death-insurance-wl.svg">
              <h1 class="cj-header-title">Calcular precio del seguro de decesos</h1>
            </div>
          </div>
          <div class="cj-header-usp hidden-xs">

            <ul>
              <li>
                <span class="icon icon-check"></span>
                <p>Te asesoramos para que encuentres <strong>el mejor seguro de decesos</strong> porque somos corredores
                  de seguros</p>
              </li>
              <li><span class="icon icon-check"></span>
                <p>Calcula los <strong>mejores precios y coberturas</strong> en 2 minutos</p>
              </li>
              <li><span class="icon icon-check"></span>
                <p>Ahorra en tu seguro de defunción con la ayuda de nuestros asesores</p>
              </li>
            </ul>
          </div>
          <div class="seo-block hidden-mobile">
            <div class="row row-flex">
              <div class="col-xs-12">
                <div class="seo-text">
                  <h2>
                    ¿Cómo calcular el precio de tu seguro de decesos?
                  </h2>
                  <p>
                    Con <strong>Rastreator</strong> puedes calcular tu <strong>seguro de decesos</strong> de la forma
                    más
                    sencilla y rápida posible. Tan solo
                    tendrás que indicarnos tu edad y tu código postal y en pocos segundos accederás a una página con
                    todas las
                    ofertas que las aseguradoras tienen para ti. De esta forma, podrás elegir la póliza que mejor se
                    ajuste a
                    ti, comparando entre los precios y coberturas de diferentes aseguradoras.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-column">

          <div class="card-wrapper" (click)="hideHelpIfOpen()">
            <div class="container">
              <div class="row">
                <div class="col-xs-12 col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-3">
                  <div class="card shadow-2" style="">
                    <div class="question-wrapper">
                      <div class="small-textbox date-input">

                        <!--<h3 class="">Personas a incluir en el seguro</h3>-->
                        <h3 class="">Datos del asegurado 1</h3>
                        <div class="row">
                          <div class="col-xs-12  col-md-6">
                            <p class="section-subtitle">Fecha de nacimiento</p>
                            <div app-primary-dob [isUpaEnable]="upaPlugings?.isEnabled"
                              [isUserLoggedIn]="isUserLoggedIn" [upaUserData]="upaUserProfileDataModel"
                              (onSubmit)="submitPrimaryDOB($event)"></div>

                          </div>
                          <div class="col-xs-12  col-md-6">
                            <p class="section-subtitle">Sexo</p>
                            <ng-container *ngIf="initialConfig">
                              <div app-gender [isUpaEnable]="upaPlugings?.isEnabled" [isUserLoggedIn]="isUserLoggedIn"
                                [upaUserData]="upaUserProfileDataModel" [initialConfig]="initialConfig"
                                (onSubmit)="submitGenderAnswer($event)"></div>
                            </ng-container>

                          </div>
                        </div>
                      </div>
                      <div class="form-with-lbl add-data small-textbox ">
                        <div class="row row-counter">
                          <app-additional-insurers (onSubmit)="addInsurers($event)"></app-additional-insurers>
                        </div>
                      </div>
                      <div class="control-add">
                        <img src="{{baseMakeImageUrl}}plus.svg" alt="" class="count-plus" id="count-plus"
                          (click)="addInsurer()">
                        <img src="{{baseMakeImageUrl}}minus.svg" *ngIf="contractType.policyHolder.length > 1" alt=""
                          class="count-minus" id="count-minus" (click)="removeInsurer()">
                        <p class="control-txt" *ngIf="contractType.policyHolder.length === 1">Añadir personas a asegurar
                        </p>
                        <p class="control-txt" *ngIf="contractType.policyHolder.length > 1">Añadir o eliminar personas a
                          asegurar</p>
                      </div>



                      <div class="form-with-lbl add-data">

                        <div class="row">
                          <div class="col-xs-12 col-sm-4">
                            <div app-postal-code [isUpaEnable]="upaPlugings?.isEnabled"
                              [isUserLoggedIn]="isUserLoggedIn" [upaUserData]="upaUserProfileDataModel"
                              (onSubmit)="submitPostalCode($event)"></div>
                          </div>
                          <div class="col-xs-12 col-sm-8">
                            <div app-email [isUpaEnable]="upaPlugings?.isEnabled" [isUserLoggedIn]="isUserLoggedIn"
                              [upaUserData]="upaUserProfileDataModel" *ngIf="!upaPlugings?.isEnabled"
                              (onSubmit)="submitEmail($event)"></div>

                            <div app-email [isUpaEnable]="upaPlugings?.isEnabled" [isUserLoggedIn]="isUserLoggedIn"
                              [upaUserData]="upaUserProfileDataModel"
                              *ngIf="upaPlugings?.isEnabled && isUserLoggedIn && isUserAlreadyLogin && !isSw"
                              (onSubmit)="submitEmail($event)"></div>

                            <div class="not-you-link"
                              *ngIf="upaPlugings?.isEnabled && isUserLoggedIn && isUserAlreadyLogin" id="itIsYou">
                              <a href="javascript:void(0)" (click)="isItNotYou();">¿No eres tú?</a>
                            </div>
                          </div>

                        </div>
                      </div>





                      <div app-telephone [isUpaEnable]="upaPlugings?.isEnabled" [isUserLoggedIn]="isUserLoggedIn"
                        [upaUserData]="upaUserProfileDataModel" (onSubmit)="submitTelePhone($event)"></div>


                      <div class="form-control normal-checkbox" *ngIf="!upaPlugings?.isEnabled">
                        <div app-privacy-policy (onSubmit)="submitPrivacyPolicy($event)"></div>
                      </div>
                      <div class="form-control normal-checkbox" *ngIf="upaPlugings?.isEnabled && isUserAlreadyLogin">
                        <div app-privacy-policy (onSubmit)="submitPrivacyPolicy($event)"></div>
                      </div>
                    </div>
                    <div class="options-wrapper">
                      <a href="#" id="prev" class="btn rounded prev none">

                        <i class="icon icon-chevron-left"></i>
                      </a>
                      <a id="next" *ngIf="!isSw" (click)="submitAnswer()" class="btn solid-main next text-08-d-regular"
                        style="cursor:pointer">Ver resultados</a>
                      <a *ngIf="isSw" (click)="submitSWAnswer()" id="btnUpdateResults"
                        class="btn optional solid-main next text-08-d-regular" style="cursor:pointer">Actualizar
                        resultados</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cj-header-usp visible-xs">
          <ul>
            <li>
              <span class="icon icon-check"></span>
              <p>Te asesoramos para que encuentres <strong>el mejor seguro de decesos</strong> porque somos corredores
                de seguros</p>
            </li>
            <li><span class="icon icon-check"></span>
              <p>Calcula los <strong>mejores precios y coberturas</strong> en 2 minutos</p>
            </li>
            <li><span class="icon icon-check"></span>
              <p>Ahorra en tu seguro de defunción con la ayuda de nuestros asesores</p>
            </li>
          </ul>
          <div class="seo-block">
            <div class="row row-flex">
              <div class="col-xs-12">
                <div class="seo-text">
                  <h2>
                    ¿Cómo calcular el precio de tu seguro de decesos?
                  </h2>
                  <p>
                    Con <strong>Rastreator</strong> puedes calcular tu <strong>seguro de decesos</strong> de la forma
                    más
                    sencilla y rápida posible. Tan solo
                    tendrás que indicarnos tu edad y tu código postal y en pocos segundos accederás a una página con
                    todas las
                    ofertas que las aseguradoras tienen para ti. De esta forma, podrás elegir la póliza que mejor se
                    ajuste a
                    ti, comparando entre los precios y coberturas de diferentes aseguradoras.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ras-ayuda-box></ras-ayuda-box>
<footer>
  <div class="container">
    <div class="row">
      <div class="col-xs-12 hidden-sm hidden-md hidden-lg">
        <div class="collapse">
          <p class="collapse-trigger" (click)="TogglePrivacyPolicy()">Recuerda revisar la información básica de
            privacidad <span (click)="TogglePrivacyPolicy()" class="icon icon-chevron-down"
              [ngClass]="!isPrivacyPolicyCollapsed ? '' : 'active'" (click)="TogglePrivacyPolicy()"></span></p>
          <div class="collapsed" [ngClass]="!isPrivacyPolicyCollapsed ? '' : 'active'">
            <p>Los datos facilitados a RASTREATOR COMPARADOR CORREDURÍA DE SEGUROS, S.L.U., corredor de seguros
              registrado en la DGSFP con nº J3257, con seguro responsabilidad civil contratado (C/ Sánchez Pacheco, 85,
              28002 de Madrid – DPO <a href="mailto:tusderechos@rastreator.com">tusderechos@rastreator.com</a>) serán
              tratados para prestarte el servicio que has solicitado. Además, tus datos podrán ser comunicados a
              entidades colaboradoras de Rastreator, con la finalidad de proporcionarte el servicio. Dicho tratamiento
              se fundamenta en la necesidad de llevarlo a cabo para desarrollar la prestación de dicho servicio. Puedes
              ejercer tus derechos de acceso, rectificación, supresión y oposición, entre otros, dirigiéndote por
              escrito a Rastreator al domicilio señalado o a <a
                href="mailto:datospersonales@rastreator.com">datospersonales@rastreator.com</a>. Para más información,
              visita nuestra <a href="https://www.rastreator.com/politica-de-privacidad.aspx" target="_blank">Política
                de Privacidad</a>.</p>
          </div>
        </div>
        <div class="divider hidden-sm hidden-md hidden-lg"></div>
      </div>
      <div class="col-xs-12 col-sm-8 col-md-8 legal">
        <ul class="clearfix">
          <li><a
              href="{{ (isSegurosUser) ? 'https://www.seguros.es/aviso-legal/' : 'https://www.rastreator.com/aviso-legal.aspx'}}"
              target="_blank" class="blue-02-bg">Aviso legal</a></li>
          <li><a
              href="{{ (isSegurosUser) ? 'https://www.seguros.es/informacion-cookies/' : 'https://www.rastreator.com/politica-de-cookies.aspx'}}"
              target="_blank" class="blue-02-bg">Política de cookies</a></li>
          <li><a
              href="{{ (isSegurosUser) ? 'https://www.seguros.es/privacidad/' : 'https://www.rastreator.com/politica-de-privacidad.aspx'}}"
              target="_blank" class="blue-02-bg">Política de privacidad</a></li>
          <li><a
              href="{{ (isSegurosUser) ? 'https://www.seguros.es/informacion-previa-del-mediador/' : 'https://www.rastreator.com/informacion-previa-del-mediador.aspx'}}"
              target="_blank" class="blue-02-bg">Info previa</a></li>
        </ul>
        <div class="collapse hidden-xs">
          <p class="collapse-trigger" (click)="TogglePrivacyPolicy()">Recuerda revisar la información básica de
            privacidad <span class="icon icon-chevron-down"
              [ngClass]="!isPrivacyPolicyCollapsed ? '' : 'active'"></span></p>
          <div class="collapsed" [ngClass]="!isPrivacyPolicyCollapsed ? '' : 'active'">
            <p>Los datos facilitados a RASTREATOR COMPARADOR CORREDURÍA DE SEGUROS, S.L.U., corredor de seguros
              registrado en la DGSFP con nº J3257, con seguro responsabilidad civil contratado (C/ Sánchez Pacheco, 85,
              28002 de Madrid – DPO <a href="mailto:tusderechos@rastreator.com">tusderechos@rastreator.com</a>) serán
              tratados para prestarte el servicio que has solicitado. Además, tus datos podrán ser comunicados a
              entidades colaboradoras de Rastreator, con la finalidad de proporcionarte el servicio. Dicho tratamiento
              se fundamenta en la necesidad de llevarlo a cabo para desarrollar la prestación de dicho servicio. Puedes
              ejercer tus derechos de acceso, rectificación, supresión y oposición, entre otros, dirigiéndote por
              escrito a Rastreator al domicilio señalado o a <a
                href="mailto:datospersonales@rastreator.com">datospersonales@rastreator.com</a>. Para más información,
              visita nuestra <a href="https://www.rastreator.com/politica-de-privacidad.aspx" target="_blank">Política
                de Privacidad</a>.</p>
          </div>
        </div>
        <div class="divider hidden-sm hidden-md hidden-lg"></div>
      </div>
      <div class="col-xs-12 col-sm-4 col-md-7 copyright-wrapper">
        <!-- Si no tenemos legal, debemos añadir la clase full-width para que ocupe todo el ancho -->
        <p class="copyright">&copy; Copyright Rastreator.com {{currentYear}}.<br /> Todos los derechos reservados</p>
      </div>
    </div>
  </div>
</footer>
<ras-recaptchav3></ras-recaptchav3>
<ras-upa-plugins [isWS]="isSw"></ras-upa-plugins>